import { text_mod_41, } from "../text/Text.js";
export const module41 = {
  title:
    "Літера Я велика",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_41,
    },
  ]
};